<t4-header icon="glyphicon-stats" title="{{'T4.Campaigns.PartnerCampaign.lblheader' |translate : 'Offers' }}">
  <button (click)="createCampaign()" mat-button color="primary" matTooltip="{{ 'T4.Campaigns.PartnerCampaign.generatebutton' | translate : 'Generate Campaign'}}"  style="margin-left: 10px; float: left;" class="btn btn-default"><mat-icon>campaign</mat-icon>&nbsp;{{ 'T4.Campaign.createCampaign.lblcreate' | translate : 'Create'}}</button>
</t4-header>
<t4-container title="{{ 'T4.Campaigns.PartnerCampaign.lbllist' | translate : 'Offers' }}">
  <mat-tab-group [(selectedIndex)]="selectedIndex">

    <mat-tab label="{{ 'T4.Campaigns.PartnerCampaign.lblActivePartnerCampaings' | translate : 'Active offers' }}">
      <div style="display: flex; flex-wrap: wrap;">
        <ng-container *ngIf="!activeIsLoading && activePartnerCampaigns.length == 0">
          <p style="margin:15px auto 15px auto">{{ 'T4.Campaigns.PartnerCampaign.msgNoActiveOffers' | translate : 'No current active offers' }}</p>
        </ng-container>
        <mat-spinner *ngIf="activeIsLoading" style="margin:auto;"></mat-spinner>
        <ng-container *ngFor="let campaign of activePartnerCampaigns">
          <div style="position: relative; max-width: 300px; margin: 10px; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12); background-color: white; border-radius:15px;">
            @if(campaign.PartnerOfferType != 3){
            <div style="text-align: center; max-width:300px; max-height:300px; margin:auto; align-content:center; border-radius:15px 15px 0 0; overflow:hidden;">
              <img [src]="campaign.Image.Uri ? campaign.Image.Uri : '/Images/DiscountPlaceholder.jpg'" alt="Image Missing" style="width:100%;">
            </div>
            }
            <div style="padding:10px;">
              <div style="text-align:center">

                <h1 class="fixed-height-title">
                  <span *ngIf="campaign.Title && campaign.Title.trim() !== ''">{{campaign.Title}}</span>
                </h1>

                <p class="fixed-height-desc">
                  <span *ngIf="campaign.Comment && campaign.Comment.trim() !== ''">{{campaign.Comment}}</span>
                </p>
            
              </div>
              <div style="text-align:center;">
                <button style="border-radius:25px;" mat-raised-button color="primary" (click)="editCampaign(campaign)">{{ 'T4.CampaignCard.btnEdit' | translate:'Edit'}}</button>
                <p *ngIf="campaign.ValidFrom && currentTime > campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateUntil' | translate:'Valid until'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
                <p *ngIf="campaign.ValidFrom && currentTime < campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateBetween1' | translate:'Valid between'}} {{campaign.ValidFrom | date: 'dd-MMM'}} {{ 'T4.CampaignCard.dateBetween2' | translate:'and'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
                @if(campaign.PartnerOfferType == 1){
                <p style="color:black; margin:0.3em; font-size:0.6em; margin-bottom:10px;">{{ 'T4.CampaignCard.txtDisclamer' | translate:'The coupon is redeemed in-Station, show the code at the checkout.'}}</p>
                }
                @else if(campaign.PartnerOfferType == 2 && campaign.PartnerOfferDisclaimer != ''){
                <p style="color:black; margin:0.3em; font-size:0.6em; margin-bottom:10px;">{{ campaign.PartnerOfferDisclaimer }}</p>
                }
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'T4.Campaigns.PartnerCampaign.lblPastPartnerCampaings' | translate : 'Past offers' }} ">
      <div style="display: flex; flex-wrap: wrap;">
        <ng-container *ngIf="!archivedisLoading && historicalPartnerCampaigns.length == 0">
          <p style="margin:15px auto 15px auto">{{ 'T4.Campaigns.PartnerCampaign.msgNoArchivedOffers' | translate : 'No current past offers' }}</p>
        </ng-container>
        <mat-spinner *ngIf="archivedisLoading" style="margin:auto;"></mat-spinner>
        <ng-container *ngFor="let campaign of historicalPartnerCampaigns">
          <div style="position: relative; max-width: 300px;  margin: 10px; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12); background-color: white; border-radius:15px;">
            <div style="text-align: center; max-width: 300px; max-height: 300px; margin: auto; align-content: center; border-radius:15px 15px 0 0; overflow:hidden;">
              <img [src]="campaign.Image.Uri ? campaign.Image.Uri : '/Images/DiscountPlaceholder.jpg'" alt="Image Missing" style="width:100%; max-height:300px">
            </div>
            <div style="padding:10px;">
              <div style="text-align:center">

                <h1 class="fixed-height-title">
                  <span *ngIf="campaign.Title && campaign.Title.trim() !== ''">{{campaign.Title}}</span>
                </h1>


                <p class="fixed-height-desc">
                  <span *ngIf="campaign.Comment && campaign.Comment.trim() !== ''">{{campaign.Comment}}</span>
                </p>
                <button style="border-radius:25px;" mat-raised-button color="primary" disabled (click)="editCampaign(campaign)">{{ 'T4.CampaignCard.btnEnded' | translate:'Ended'}}</button>
                <p *ngIf="campaign.ValidFrom && currentTime > campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateUntil' | translate:'Valid until'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
                <p *ngIf="campaign.ValidFrom && currentTime < campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateBetween1' | translate:'Valid between'}} {{campaign.ValidFrom | date: 'dd-MMM'}} {{ 'T4.CampaignCard.dateBetween2' | translate:'and'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

</mat-tab-group>
</t4-container>

<t4-container title="{{ 'T4.Campaigns.PartnerCampaign.lblInheritedOffers' | translate : 'inherited offers ' }}" *ngIf="selectedIndex == 0">
  <div style="display:flex; flex-wrap:wrap">
    <ng-container *ngIf="!activeIsLoading && inheritedPartnerCampaigns.length == 0">
      <p style="margin:15px auto 15px auto">{{ 'T4.Campaigns.PartnerCampaign.msgNoInheritedOffers' | translate : 'No current inherited offers' }}</p>
    </ng-container>
    <ng-container *ngFor="let campaign of inheritedPartnerCampaigns">
      <div style="position: relative; max-width: 300px; margin: 10px; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12); background-color: white; border-radius:15px;">
        <div style="text-align: center; max-width:300px; max-height:300px; margin:auto; align-content:center; border-radius:15px 15px 0 0; overflow:hidden;">
          <img [src]="campaign.Image.Uri ? campaign.Image.Uri : '/Images/DiscountPlaceholder.jpg'" alt="Image Missing" style="width:100%;">
        </div>
        <div style="padding:10px;">
          <div style="text-align:center">

            <h1 class="fixed-height-title">
              <span *ngIf="campaign.Title && campaign.Title.trim() !== ''">{{campaign.Title}}</span>
            </h1>

            <p class="fixed-height-desc">
              <span *ngIf="campaign.Comment && campaign.Comment.trim() !== ''">{{campaign.Comment}}</span>
            </p>

          </div>
          <div style="text-align:center;">
            <button style="border-radius:25px;" mat-raised-button color="primary" (click)="editCampaign(campaign)">{{ 'T4.CampaignCard.btnShow' | translate:'Show'}}</button>
            <p *ngIf="campaign.ValidFrom && currentTime > campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateUntil' | translate:'Valid until'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
            <p *ngIf="campaign.ValidFrom && currentTime < campaign.ValidFrom" style="font-size:13px; color:gray; margin:0; margin-top:10px;">{{ 'T4.CampaignCard.dateBetween1' | translate:'Valid between'}} {{campaign.ValidFrom | date: 'dd-MMM'}} {{ 'T4.CampaignCard.dateBetween2' | translate:'and'}} {{campaign.ValidThrough | date: 'dd-MMM' }}</p>
            @if(campaign.PartnerOfferType == 1){
            <p style="color:black; margin:0.3em; font-size:0.6em; margin-bottom:10px;">{{ 'T4.CampaignCard.txtDisclamer' | translate:'The coupon is redeemed in-Station, show the code at the checkout.'}}</p>
            }
            @else if(campaign.PartnerOfferType == 2 && campaign.PartnerOfferDisclaimer != ''){
            <p style="color:black; margin:0.3em; font-size:0.6em; margin-bottom:10px;">{{ campaign.PartnerOfferDisclaimer }}</p>
            }
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</t4-container>
